import React from 'react';
import { Link } from 'react-router-dom';
import { UserShape } from '../shapes';
import PropTypes from 'prop-types';
import Person from '../components/person';

export default class CreateAccount extends React.Component {
  static propTypes = {
    user: UserShape,
    onStartCreateAccountProcess: PropTypes.func
  }

  state = {
    createAccountProcessTriggered: false,
    email: undefined
  }

  render() {
    if (this.props.user.get('error')) {
      return this.renderCreateAccountError();
    } else if (this.state.createAccountProcessTriggered) {
      return this.renderCreateAccountProcessTriggered();
    } else {
      return this.renderPerson();
    }
  }

  renderCreateAccountProcessTriggered() {
    return (
      <div className='row confirmation'>
        <div className='offset-sm-1 col-sm-10'>
          { `Right on. We've sent you an email with a link to confirm your account. Check your inbox!`}
        </div>
        <div className='col-sm-12 action center'>
          <Link to='/' className='btn btn-dark' data-primary-cta='true'>Got It</Link>
        </div>
      </div>
    );
  }

  renderPerson() {
    return(
      <div>
        <div className='row email-explainer-section'>
          <div className='offset-sm-1 col-sm-10'>
            <h1>Sign up</h1>
            <p>
              Yak Tack uses a spaced-repetition technique to help people remember words.
            </p>
            <p>
              Enter your email address below. We’ll create your account, then we'll send a confirmation link to your inbox. That's it!
            </p>
            <p>
              Oh, and we'll never spam you. Period.
            </p>
          </div>
        </div>
        <div className='clearfix'></div>
        <div className='row'>
          <div className='offset-sm-1 col-sm-10'>
            <Person email={this.state.email} onEmailChange={this.onEmailChange.bind(this)}></Person>            
            <div className='action'>
              <Link to='/' className='btn btn-outline-secondary'>Nevermind</Link>
              <button data-behavior='create-account' onClick={ this.onStartCreateAccountProcess.bind(this) } className='btn btn-dark' type='button' data-primary-cta='true'>Sign up</button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderCreateAccountError() {
    return(
      <div className='error' >
        <div className='col-sm-12'>
          { `Hmm. ${ this.props.user.get('error') }.` }
        </div>
        <div className='col-sm-12 action center'>
          <Link to='/' className='btn btn-dark' data-primary-cta='true'>Ah, Ok</Link>
        </div>
      </div>
    );
  }

  onEmailChange(event) {
    this.setState({
      email: event.target.value
    });
  }

  onStartCreateAccountProcess() {
    this.props.onStartCreateAccountProcess(this.state.email);
    this.setState({ createAccountProcessTriggered: true });
  }
}



// WEBPACK FOOTER //
// ./src/components/create_account.jsx